import { chassis } from "../../../../data/vehicle";
import { VehicleFeature } from "../../../../interface/transportation";
import { Button } from "../../../atoms/Buttons";
import { CmpInfoCharacteristicBox } from "../CmpInfoCheckBox";
import * as S from "./cmpCarManagementInfoContent.styles";

interface CmpCarInfoContentProps {
  register: any;
  setValue: any;
  watch: any;
  onVehicleInfoChangePageMoveHanlder: () => void;
}

export const CmpCarManagementInfoContent = ({
  register,
  setValue,
  watch,
  onVehicleInfoChangePageMoveHanlder,
}: CmpCarInfoContentProps) => {
  const selectChassis = chassis.find((item) => item.id === watch("chassis"));
  const displayValue = selectChassis?.display;

  return (
    <S.CmpCarManagementInfoContent>
      <S.CmpCarInfoConentBox>
        <S.CmpCarInfoQuest>
          <span>차량정보</span>
        </S.CmpCarInfoQuest>
        <S.CmpCarInfoItem>
          <p className="small">차량번호</p>
          <p>{watch("vehicleNumber")}</p>
        </S.CmpCarInfoItem>
        <S.CmpCarInfoItem>
          <p className="small">차종</p>
          <p>{watch("vehicleType")}</p>
        </S.CmpCarInfoItem>
        <S.CmpCarInfoItem>
          <p className="small">규격</p>
          <p>{watch("standard")}</p>
        </S.CmpCarInfoItem>
        <S.CmpCarInfoItem>
          <p className="small">샤시</p>
          <p>{displayValue}</p>
        </S.CmpCarInfoItem>

        <hr
          style={{
            background: "rgba(232, 232, 232, 1)",
            height: "1px",
            width: "100%",
            border: "0",
          }}
        />

        <S.CmpCarInfoQuest>
          <span>차량특성</span>
        </S.CmpCarInfoQuest>
        <S.CmpCarCheckDetail>
          <CmpInfoCharacteristicBox
            label="위험물"
            register={register("vehicleFeatures")}
            value={VehicleFeature.DANGEROUS_GOODS}
            setValue={setValue}
            watch={watch}
          />
          <CmpInfoCharacteristicBox
            label="보세운송"
            register={register("vehicleFeatures")}
            value={VehicleFeature.BOND_MOVEMENT}
            setValue={setValue}
            watch={watch}
          />
          <CmpInfoCharacteristicBox
            label="발전기"
            register={register("vehicleFeatures")}
            value={VehicleFeature.GENERATOR}
            setValue={setValue}
            watch={watch}
          />
          <CmpInfoCharacteristicBox
            label="냉장"
            register={register("vehicleFeatures")}
            value={VehicleFeature.REFRIGERATED}
            setValue={setValue}
            watch={watch}
          />
          <CmpInfoCharacteristicBox
            label="냉동"
            register={register("vehicleFeatures")}
            value={VehicleFeature.FROZEN}
            setValue={setValue}
            watch={watch}
          />
        </S.CmpCarCheckDetail>
      </S.CmpCarInfoConentBox>
      <Button
        type="button"
        size="full"
        color="primary"
        label="차량정보 변경"
        onClick={onVehicleInfoChangePageMoveHanlder}
      />
    </S.CmpCarManagementInfoContent>
  );
};
